import { inject, injectable } from "inversify";
import IAlertService from "../alert/IAlertService";
import { DiTokens } from "../diTokens";
import IErrorService from "../error/IErrorService";
import BaseOperationService from "../operations/BaseOperationService";
import { CardLimitsModel } from "../../models/cardOperations/CardLimitsModel";
import { ConfigStore } from "../../store/modules/config";
import { ContractsStore } from "../../store/modules/contracts";
import { CardLimit } from "../../data/cardLimits";
import { ContractsApi } from "../api/ContractsApi";
import currencyFilter from "../../filters/currency.filter";
import i18n from "@/i18n";

/**Сервис проведения операций */
@injectable()
export default class CardLimitsService extends BaseOperationService {
  constructor(
    @inject(DiTokens.AlertService) public alertService: IAlertService,
    @inject(DiTokens.ErrorService) public errorService: IErrorService
  ) {
    super(alertService, errorService);
  }

  /**Стор счетов */
  public ContractsStore!: ContractsStore

  /**
   * Инициализация операции
   * @param initData Данные для инициализации
   * */
  public async init(params: any, configStore: ConfigStore, contractsStore: ContractsStore): Promise<CardLimitsModel> {
    const operationData = new CardLimitsModel(params.cardId);
    operationData.RespondentCode = configStore.apiData.OperationCodeOfSetCardLimits;
    try {
      const limits: Array<CardLimit> = await ContractsApi.getCardLimits(params.cardId);
      limits.map((limit: CardLimit) => {
        limit.Currency = currencyFilter(params.contract.Data.CurrencyCharCode);
        if (limit.CountCode || limit.SummaCode)
          operationData.cardLimits.push(limit);
      });
      operationData.cardLimits = operationData.cardLimits.sort(function (a, b) {
        return a.CategoryOrder - b.CategoryOrder;
      });
    } catch (e) {
      this.alertService.error(e);
    }
    this.ContractsStore = contractsStore
    return operationData;
  }

  /**
   * Действия после проведения операции
   */
  // public async afterExecute(
  //   model: CardLimitsModel
  // ): Promise<void> {
  //   this.ContractsStore.updateCardBlock({
  //     contractId: model.contract.Data.Id,
  //     cardId:  model.card.Data.Id,
  //     block: model.isBlock
  //   });
  //   this.alertService.success(
  //     i18n
  //       .t(
  //         `main.cards.messages.${
  //           model.isBlock ? "blocked" : "unblocked"
  //         }`,
  //         { pan: model.card.Data.Number }
  //       )
  //       .toString()
  //   );
  // }

  // /**Вычисляем статус операции после выполнения */
  // public async analyzeState(model: CardBlockModel, ord: OperationRequestData): Promise<CardBlockModel> {
  //   model._actionState =
  //     ord.requestState == RequestsStates.Executed || ord.requestState == RequestsStates.None
  //       ? ActionStateEnum.Success
  //       : [3, 6, 7].indexOf(ord.requestState as number)
  //         ? ActionStateEnum.Error
  //         : ActionStateEnum.Executing;
  //   model.ActionStateText = ord.requestStateDescription;
  //   return model
  // }
}
